import type {
    AuthorizedMedicationInfoFragment,
    MedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../../../graphql/generated/graphql';
import type { MedicationOverride } from '../../../hooks/use-config-api';

/**
 * Gets the package size unit for a medication, considering any configuration overrides
 */
export const getMedicationPackageSizeUnit = (
    medication?:
        | AuthorizedMedicationInfoFragment
        | MedicationInfoFragment
        | UnknownMedicationInfoFragment,
    medicationOverride?: MedicationOverride
): string => {
    if (
        medication?.__typename === 'AuthorizedMedication' ||
        medication?.__typename === 'Medication'
    ) {
        return (
            medicationOverride?.packageSizeUnit ?? medication.packageSizeUnit
        );
    }
    return medicationOverride?.packageSizeUnit ?? '';
};

/**
 * Formats a quantity with the appropriate package size unit for a medication
 */
export const formatMedicationQuantity = (
    quantity: number | string,
    medication?:
        | AuthorizedMedicationInfoFragment
        | MedicationInfoFragment
        | UnknownMedicationInfoFragment,
    medicationOverride?: MedicationOverride
): string => {
    const packageSizeUnit = getMedicationPackageSizeUnit(
        medication,
        medicationOverride
    );
    return `${quantity} ${packageSizeUnit}`;
};
